export class PauseState {
    paused: boolean
    remainingPauseTime?: number | undefined
}
